import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';

/**
 * Wrapper component for Ant Design Checkbox
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Checkbox functionality including indeterminate state and group options.
 * 
 * @component
 * @example
 * import { Checkbox } from '../GeneralComponents/ui';
 * 
 * <Checkbox>Checkbox</Checkbox>
 * <Checkbox defaultChecked>Default Checked</Checkbox>
 * <Checkbox disabled>Disabled</Checkbox>
 * <Checkbox indeterminate>Indeterminate</Checkbox>
 * 
 * @see https://ant.design/components/checkbox/ - Ant Design Checkbox documentation
 */
const Checkbox = (props) => {
  return <AntCheckbox {...props} />;
};

Checkbox.Group = AntCheckbox.Group;

export default Checkbox;

